import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { LockOutlined } from '@ant-design/icons'
import { ListEmpty } from '../../components/card_list/CardList'
import i from '../../translations/i'
import controller from './super.controller'

// Разделы суперадминки остальным не показываем; сервер их всё равно не пустит (protected/*)
export const SuperGuard = observer(({ children }: { children: React.ReactNode }) => {
    useEffect(() => {
        controller.check()
    }, [])

    if (!controller.checked) return <></>
    if (!controller.isSuper) return <ListEmpty icon={<LockOutlined />} title={i.t('superAdmin:onlySuper')} />

    return <>{children}</>
})
